import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { McpServerModel } from '../policy-mcp-server-filtering/policy-mcp-server-filtering.component';

@Component({
  selector: 'app-add-mcp-server-dialog',
  templateUrl: './add-mcp-server-dialog.component.html',
  styleUrls: ['./add-mcp-server-dialog.component.scss'],
})
export class AddMcpServerDialogComponent implements OnInit {
  public addMcpServersFormGroup: FormGroup;
  public maxMcpServersToAdd = 10;

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly _dialogRef: MatDialogRef<AddMcpServerDialogComponent>
  ) {}

  ngOnInit(): void {
    this._initializeForm();
  }

  public get mcpServersToAdd(): FormArray {
    return this.addMcpServersFormGroup.get('mcpServersToAdd') as FormArray;
  }

  public addMoreClicked(): void {
    if (this.mcpServersToAdd.controls.length < this.maxMcpServersToAdd) {
      this.mcpServersToAdd.push(this._createMcpServerFormGroup());
    }
  }

  public removeMcpServer(index: number): void {
    this.mcpServersToAdd.removeAt(index);
  }

  public onClose(): void {
    this._dialogRef.close();
  }

  public onSubmit(): void {
    if (this.addMcpServersFormGroup.valid) {
      const mcpServersToAdd: McpServerModel[] = this.mcpServersToAdd.controls
        .map((control) => control.value)
        .filter((value) => value.url && value.url.trim() !== '')
        .map((value) => ({
          url: value.url,
        }));
      this._dialogRef.close(mcpServersToAdd);
    }
  }

  private _initializeForm(): void {
    this.addMcpServersFormGroup = this._formBuilder.group({
      mcpServersToAdd: this._formBuilder.array([this._createMcpServerFormGroup()]),
    });
  }

  private _createMcpServerFormGroup(): FormGroup {
    return this._formBuilder.group({
      url: ['', [Validators.required, Validators.pattern(/^https?:\/\/.+/)]],
    });
  }
}
